import { phoneClear } from '.';

function phoneFormat(phone: string | null | undefined): string {
  const cleared = phoneClear(phone);

  if (phone == null || phone.length === 0) {
    return '';
  }

  let result = '+';

  // 7....
  if (cleared.length > 0) {
    result += '7';

    // 79.....
    if (cleared.length > 1) {
      result += ' (9';

      // 79C
      if (cleared.length > 2) {
        result += cleared[2];

        // 79CC
        if (cleared.length > 3) {
          result += cleared[3];
        }

        if (cleared.length > 4) {
          result += ') ' + cleared[4];
        }

        if (cleared.length > 5) {
          result += cleared[5];
        }

        if (cleared.length > 6) {
          result += cleared[6];

          if (cleared.length > 7) {
            result += '-' + cleared[7];
          }

          if (cleared.length > 8) {
            result += cleared[8];
          }

          if (cleared.length > 9) {
            result += '-' + cleared.substring(9);
          }
        }
      }
    }
  }

  return result;
}

export default phoneFormat;
